import { SET_ANALYTICS } from '../constants/actualization';
import { HIT_ACTUALIZE_PRICE_CHANGE } from '../constants/analytics';

export const setAnalytics = () => ({
  type: SET_ANALYTICS,
});

export const hitActualizePriceChange = () => ({
  type: HIT_ACTUALIZE_PRICE_CHANGE,
});
